<template>
  <LightBox dense>
    <FormHeading :h="5" class="ms-1">
      {{ $tt('passport') }} #{{ i + 1 }}: {{ buildFullname(passport) }}
    </FormHeading>
    <v-divider />
    <ul class="ms-1">
      <li v-if="'nationality' in passport">
        {{ $tt('nationality') }}: 
        <strong>{{ tCountry(passport.nationality) }}</strong>
      </li>
      <li v-if="'number' in passport">
        {{ $tt('form_review.number') }}:
        <strong>{{ passport.number }}</strong>
      </li>
      <li v-if="'dateOfIssue' in passport">
        {{ $tt('form_review.date_of_issue') }}:
        <strong>{{ formatDate(passport.dateOfIssue) }}</strong>
      </li>
      <li v-if="'dateOfExpiry' in passport">
        {{ $tt('form_review.date_of_expiry') }}:
        <strong>{{ formatDate(passport.dateOfExpiry) }}</strong>
      </li>
      <li v-if="'countryOfBirth' in passport">
        {{ $tt('birth_country') }}:
        <strong>{{ tCountry(passport.countryOfBirth) }}</strong>
      </li>
      <li v-if="'dateOfBirth' in passport">
        {{ $tt('birth_date') }}:
        <strong>{{ formatDate(passport.dateOfBirth) }}</strong>
      </li>
      <li v-if="'sex' in passport">
        {{ $tt('sex') }}:
        <strong>{{ $tt(passport.sex == 'm' ? 'male' : 'female') }}</strong>
      </li>
    </ul>
  </LightBox>
</template>

<script setup lang="ts">
import { buildFullname } from '~/helpers/format';
import type { Applicant } from '~/types';

const props = defineProps<{
  i: number;
  applicant: Applicant;
}>();

const { tCountry } = useLocalization();
const { formatDate } = useFormat();

const { passport } = props.applicant;
</script>

<style scoped>
li, .summary {
  font-size: 14px;
}
</style>